import React, { Component } from "react";
import {
	View,
	StyleSheet,
	TextInput,
	Alert,
	Platform,
	Image,
	ScrollView,
} from "react-native";
import { translate } from "react-i18next";

import { addDevice } from "api";
import { reset, push } from "utils/navigation";
import Header from "components/Header";
import BackgroundImage from "components/BackgroundImage";
import VisibilityPoller from "components/VisibilityPoller";
import ProgressIndicator from "components/ProgressIndicator";
import Text from "components/StyledText";
import ViewScroll from "components/ViewScroll";
import Button from "components/Button";
import KeyboardView from "components/KeyboardView";
import { ControlPanelIP } from "utils/config";
import { get } from "api";
import { Storage } from "utils/storage";

import * as x from "../../../styles/css";

class ConnectPoll extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = true;
	static bypass = true;

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			paused: false,
		};
		this.retry = this.retry.bind(this);
		this.duplicatePoll = this.duplicatePoll.bind(this);
		this.setDevice = this.setDevice.bind(this);
	}

	componentDidMount() {
		this.setDevice();

		this.timeout = setTimeout(() => {
			this.setState({
				timedOut: true,
			});
		}, 10000);
	}

	componentWillUnmount() {
		clearTimeout(this.timeout);
	}

	async setDevice() {
		let deviceId = null;

		if (Platform.OS === "web") {
			if (this.props.match.params.deviceId) {
				deviceId = this.props.match.params.deviceId;
			}
		} else {
			const storage = new Storage();
			deviceId = await storage.getItem("deviceId");
		}

		addDevice(deviceId).catch(err => {
			console.log(err);
			window.alert("Unable to add device", err);
			push(
				{
					web: "/",
					mobile: "Home",
				},
				this.props
			);
		});
	}

	duplicatePoll() {
		return get(ControlPanelIP)
			.then(result => result.json())
			.then(result => {
				if (result.devices && result.devices.length > 0) {
					if (!this.state.paused) {
						this.setState(
							{
								paused: true,
							},
							() => {
								push(
									{
										web: "/connect/confirm",
										mobile: "ConnectConfirm",
									},
									this.props
								);
							}
						);
					} else {
						push(
							{
								web: "/connect/confirm",
								mobile: "ConnectConfirm",
							},
							this.props
						);
					}
				}
				return result;
			})
			.catch(err => {
				console.log(err);
			});
	}

	retry() {
		push(
			{
				web: "/",
				mobile: "Home",
			},
			this.props
		);
	}

	render() {
		const nav = this.props.navigation;

		const { t } = this.props;

		return (
			<ViewScroll>
				<VisibilityPoller
					poll={this.duplicatePoll}
					paused={this.state.paused}
					duration={5}
					interval={1}
				/>
				<Header>{t("deviceAuth.connectPoll.title")}</Header>
				<View style={[x.d.flex, x.justifyContent.center]}>
					<View style={[styles.indicator]}>
						<ProgressIndicator
							loading={!this.state.paused}
							color={x.colors.default}
						/>
					</View>
					<Text help style={[x.mt.three, { textAlign: "center" }]}>
						{t("deviceAuth.connectPoll.help")}
					</Text>
				</View>

				<View style={[x.mt.auto]}>
					{this.state.timedOut && (
						<Button
							disabled={this.state.loading}
							onPress={this.retry}
							title={t("labels.retry")}
							color={x.colors.default}
						/>
					)}
				</View>
			</ViewScroll>
		);
	}
}

const styles = StyleSheet.create({
	indicator: {
		height: 10,
	},
});

export default translate()(ConnectPoll);



// WEBPACK FOOTER //
// ./src/views/DeviceAuth/ConnectPoll/index.js